import { NICmsContentComponent } from '@icms/core/content';

export namespace NCmsComponentRow {
    export const ID = 'row';

    export interface IData extends NICmsContentComponent.IData {
        columns: IColumn[];
        width?: string;
        grid_size?: number;
        grid_gap?: number;
        grid_columns_wrap?: boolean;
        align_vertical?: string;
        color?: string;
        element_id?: string;
        animate: boolean;
        animation_start_value?: number;
        showOnFacets?: string;
    }

    export interface IColumn {
        // number of columns
        size: number;
        // offset from left
        offset: number;
        // container for components
        components: NICmsContentComponent.IData[];
    }
}
